import { createSlice } from '@reduxjs/toolkit';
import {
  DEVICE_TYPES_INIT_STORE_VALUE,
  GENRES_INIT_STORE_VALUE,
  OFFER_TYPES,
  URL_PARMA_OFFER_TYPE,
  URL_PARMA_USER_OFFER_TYPE,
} from 'consts/karmaEarn';
import { getQueryParam } from 'functions/urlHelpers';
import { isClient } from 'functions/isClient';

const initOfferType = isClient() ? getQueryParam(URL_PARMA_OFFER_TYPE) : null;
const initOfferTypeValue = Object.values(OFFER_TYPES).includes(initOfferType) ? initOfferType : OFFER_TYPES.PLAY_GAMES;
const initUserOfferType = isClient() ? getQueryParam(URL_PARMA_USER_OFFER_TYPE) : null;
const initIsMyOffers = initUserOfferType === '1';
const resolvedOfferType =
  initIsMyOffers && initOfferTypeValue === OFFER_TYPES.ANSWER_SURVEYS ? OFFER_TYPES.PLAY_GAMES : initOfferTypeValue;

const initialState = {
  genres: GENRES_INIT_STORE_VALUE,
  deviceTypes: DEVICE_TYPES_INIT_STORE_VALUE,
  isMyOffers: initIsMyOffers,
  isVpnDetected: false,
  offerType: resolvedOfferType,

  page: 1,
  isLoaded: false,
  isLoading: false,
  isLastPage: false,
  karmaEarnItems: [],
};

const karmaEarnListSlice = createSlice({
  name: 'karmaEarnList',
  initialState,
  reducers: {
    receiveItems: (state, { payload }) => ({
      ...state,
      page: payload.page,
      isLoaded: true,
      isLoading: false,
      isLastPage: payload.isLastPage,
      karmaEarnItems: payload.karmaEarnItems,
    }),
    addItems: (state, { payload }) => ({
      ...state,
      page: payload.page,
      isLoaded: true,
      isLoading: false,
      isLastPage: payload.isLastPage,
      karmaEarnItems: [...state.karmaEarnItems, ...payload.karmaEarnItems],
    }),
    resetItems: state => ({
      ...state,
      isLoaded: false,
      isLastPage: false,
      karmaEarnItems: [],
    }),
    setIsMyOffers: (state, { payload }) => {
      const isMyOffers = !!payload;
      const shouldLeaveSurveys = isMyOffers && state.offerType === OFFER_TYPES.ANSWER_SURVEYS;

      return {
        ...state,
        isMyOffers,
        offerType: shouldLeaveSurveys ? OFFER_TYPES.PLAY_GAMES : state.offerType,
        ...(shouldLeaveSurveys
          ? {
              isLoaded: false,
              isLastPage: false,
              karmaEarnItems: [],
            }
          : {}),
      };
    },
    setGenres: (state, { payload }) => ({
      ...state,
      genres: payload || [],
    }),
    setDeviceTypes: (state, { payload }) => ({
      ...state,
      deviceTypes: payload || [],
    }),
    setIsLoading: (state, { payload }) => ({
      ...state,
      isLoading: !!payload,
    }),
    setIsVpnDetected: (state, { payload }) => ({
      ...state,
      isVpnDetected: !!payload,
    }),
    setOfferType: (state, { payload }) => ({
      ...state,
      offerType: payload,
      isLoaded: false,
      isLastPage: false,
      karmaEarnItems: [],
    }),
    reset: () => ({
      ...initialState,
      isMyOffers: false,
      offerType: OFFER_TYPES.PLAY_GAMES,
    }),
  },
});

export default karmaEarnListSlice;
